"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeaderboardModule = void 0;
var object_service_1 = require("@services/object-service");
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var settings_service_1 = require("@src/services/settings.service");
var cash_dom_1 = __importDefault(require("cash-dom"));
var referral_game_api_1 = require("../../api/referral-game-api");
var LeaderboardModule = /** @class */ (function () {
    function LeaderboardModule() {
        this.referralGame = object_service_1.ObjectService.getInstance(referral_game_api_1.ReferralGameAPI);
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
        this.oldSearch = undefined;
    }
    LeaderboardModule.prototype.loadModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var numberOfPlayers, leaderboard;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        (0, generator_const_1._CreateLoadingScreen)();
                        this.customerRef = document.querySelector('[data-ref="customer"]');
                        this.parentWrapper = this.customerRef.parentNode;
                        this.customerRef.style.display = 'none';
                        document.body.appendChild(this.customerRef);
                        this.highlightRef = document.querySelector('[data-ref="highlight"]');
                        this.highlightRef.style.display = 'none';
                        document.body.appendChild(this.highlightRef);
                        return [4 /*yield*/, this.referralGame.getNumberOfPlayersForGame(this.config.get.referralGame.gameId)];
                    case 1:
                        numberOfPlayers = _a.sent();
                        this.loadCounter(numberOfPlayers);
                        return [4 /*yield*/, this.referralGame.getHighscoresForGame(this.config.get.referralGame.gameId)];
                    case 2:
                        leaderboard = _a.sent();
                        /** Sort to ensure highscore is greatest */
                        leaderboard.highscoreList.sort(function (a, b) {
                            return b.totalScore - a.totalScore;
                        });
                        this.leaderBoard = leaderboard;
                        this.loadLeaderBoard(this.leaderBoard);
                        this.loadGamePlaceholders();
                        (0, generator_const_1._DeleteLoadingScreen)();
                        return [2 /*return*/];
                }
            });
        });
    };
    LeaderboardModule.prototype.loadCounter = function (numberOfPlayers) {
        var data = String((numberOfPlayers === null || numberOfPlayers === void 0 ? void 0 : numberOfPlayers.totalCount) || 0);
        var content = document.querySelector('[data-get="total-active-players"]').innerHTML;
        document.querySelector('[data-get="total-active-players"]').innerHTML = (content === null || content === void 0 ? void 0 : content.includes('{{data}}'))
            ? content.replace(/\{\{data\}\}/gi, data)
            : data;
    };
    LeaderboardModule.prototype.loadGamePlaceholders = function () {
        var gameNameElem = (0, cash_dom_1.default)("[data-get=\"gameName\"]");
        var lastUpdateElem = (0, cash_dom_1.default)("[data-get=\"lastGameUpdate\"]");
        if (gameNameElem) {
            gameNameElem.html(this.leaderBoard.name);
        }
        if (lastUpdateElem) {
            if (!this.leaderBoard.lastUpdate) {
                lastUpdateElem.html('-');
            }
            else {
                var date = new Date(this.leaderBoard.lastUpdate);
                var dd = String(date.getUTCDate()).padStart(2, '0');
                var mm = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based
                var yyyy = date.getUTCFullYear();
                var hh = String(date.getUTCHours()).padStart(2, '0');
                var min = String(date.getUTCMinutes()).padStart(2, '0');
                lastUpdateElem.html("".concat(dd, "-").concat(mm, "-").concat(yyyy, " ").concat(hh, ":").concat(min, " UTC"));
            }
        }
    };
    LeaderboardModule.prototype.loadLeaderBoard = function (leaderboard) {
        return __awaiter(this, void 0, void 0, function () {
            var users, i, index, _loop_1, this_1, _i, users_1, customer;
            return __generator(this, function (_a) {
                users = leaderboard.highscoreList;
                console.log(users);
                for (i = 0; i < users.length; i++) {
                    if (users[i].placement === undefined) {
                        users[i].placement = i + 1;
                    }
                }
                this.parentWrapper.innerHTML = '';
                index = 0;
                _loop_1 = function (customer) {
                    index++;
                    var clone = (customer.placement === 1 ? this_1.highlightRef : this_1.customerRef).cloneNode(true);
                    var getter = clone.querySelectorAll('[data-get]');
                    if (getter === null || getter === void 0 ? void 0 : getter.length) {
                        getter.forEach(function (a) {
                            var _a, _b;
                            var attr = a.getAttribute('data-get');
                            if (attr === 'index') {
                                a.innerHTML = String(index) + '.';
                            }
                            else if (attr === 'referralCode') {
                                a.innerHTML = (_a = customer === null || customer === void 0 ? void 0 : customer.username) !== null && _a !== void 0 ? _a : customer.referralCode;
                            }
                            else if (attr) {
                                a.innerHTML = (_b = customer === null || customer === void 0 ? void 0 : customer[attr]) !== null && _b !== void 0 ? _b : '';
                            }
                        });
                    }
                    clone.style.display = null;
                    this_1.parentWrapper.appendChild(clone);
                };
                this_1 = this;
                for (_i = 0, users_1 = users; _i < users_1.length; _i++) {
                    customer = users_1[_i];
                    _loop_1(customer);
                }
                return [2 /*return*/];
            });
        });
    };
    LeaderboardModule.prototype.createSearchField = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.searchField = document.querySelector('[data-ref="searchfield"]');
                this.searchField.addEventListener('keydown', function (event) {
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                    _this.performSearch(_this.searchField.value);
                });
                this.searchField.addEventListener('keyup', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    _this.performSearch(_this.searchField.value);
                });
                this.searchField.addEventListener('change', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    _this.performSearch(_this.searchField.value);
                });
                return [2 /*return*/];
            });
        });
    };
    LeaderboardModule.prototype.performSearch = function (search) {
        return __awaiter(this, void 0, void 0, function () {
            var searchRes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log(search);
                        if (!(search.length > 0 && search !== (this === null || this === void 0 ? void 0 : this.oldSearch))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.referralGame.searchForUser(this.config.get.referralGame.gameId, search)];
                    case 1:
                        searchRes = _a.sent();
                        this.parentWrapper.innerHTML = '';
                        this.loadLeaderBoard(searchRes);
                        console.log(searchRes);
                        this.oldSearch = search;
                        return [3 /*break*/, 3];
                    case 2:
                        this.loadLeaderBoard(this.leaderBoard);
                        this.oldSearch = undefined;
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return LeaderboardModule;
}());
exports.LeaderboardModule = LeaderboardModule;
